import React from 'react';
import styled from 'styled-components';

interface SectionHeaderProps {
  title: string;
  subtitle: string;
}

const Header = styled.div`
  text-align: center;
  margin-bottom: ${({ theme }) => theme.space[16]};
`;

const Title = styled.h2`
  font-size: ${({ theme }) => theme.font.size.h2};
  font-weight: ${({ theme }) => theme.font.weight.bold};
  line-height: ${({ theme }) => theme.font.lineHeight.tight};
  letter-spacing: ${({ theme }) => theme.font.letterSpacing.normal};
  margin-bottom: ${({ theme }) => theme.space[4]};
  color: ${({ theme }) => theme.color.text};
`;

const Subtitle = styled.p`
  font-size: ${({ theme }) => theme.font.size.lg};
  font-weight: ${({ theme }) => theme.font.weight.normal};
  color: ${({ theme }) => theme.color.textSecondary};
  line-height: ${({ theme }) => theme.font.lineHeight.relaxed};
  max-width: ${({ theme }) => theme.layout.measureNarrow};
  margin: 0 auto;
`;

const SectionHeader: React.FC<SectionHeaderProps> = ({ title, subtitle }) => {
  return (
    <Header>
      <Title>{title}</Title>
      <Subtitle>{subtitle}</Subtitle>
    </Header>
  );
};

export default SectionHeader;
